import kim from './Characters/Kim.js';
//import crystal from './Characters/CrystalB.js';
import crystal from './Characters/CrystalF.js';
import jan from './Characters/Jan.js';
import ron from './Characters/Ron.js';

const Characters = { ron, jan, crystal, kim, list: [ron, jan, crystal, kim] };

export default Characters;
